import { InfoCircleFilled } from '@ant-design/icons';
import { DndContext } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';
import type { FormInstance } from 'antd';
import { Alert, Divider, Form } from 'antd';

import { SList } from 'app/components/StaycationUI/List';
import type { Mode } from 'app/components/commons/Hotel/Types';
import type { HotelDiscoverExperience } from 'app/typings/hotels/Hotel/HotelDiscover';

import './ExperienceList.scss';
import { ExperienceListItem } from './ExperienceListItem/ExperienceListItem';
import { useExperienceListLogic } from './useExperienceListLogic';

export const ExperienceList = ({
  experiences,
  setIsDirtyMove,
  mode,
  form,
  isLegacy = false,
}: {
  experiences: HotelDiscoverExperience[];
  setIsDirtyMove: (value: boolean) => void;
  mode: Mode;
  form: FormInstance;
  isLegacy?: boolean;
}) => {
  const {
    alwaysIncludedExperiences,
    otherExperiences,
    onDragEnd,
    createToggleExperienceHandler,
  } = useExperienceListLogic({ experiences, form, setIsDirtyMove });

  return (
    <Form.Item name="experiences" className="experience-list-container">
      <DndContext onDragEnd={onDragEnd} id="list-grid-drag-sorting-handler">
        <div className="discover-list-experiences-container">
          <div className="staycation-discover-card__title">
            Always included overnight
          </div>
          <Alert
            type="info"
            className="blue-variant"
            icon={<InfoCircleFilled />}
            showIcon
            description={
              <ol>
                <li>
                  Sort the experiences in the list according to their relevance.
                </li>
                <li>
                  Toggle on the experiences you want to make visible in
                  Discover.
                </li>
              </ol>
            }
          />
          <div className="discover-list-experiences">
            <SortableContext items={alwaysIncludedExperiences.map((i) => i.id)}>
              <SList
                grid={{ gutter: 16, column: 1 }}
                data={alwaysIncludedExperiences}
                renderItem={(item) => (
                  <ExperienceListItem
                    experience={item}
                    mode={mode}
                    key={item.id}
                    onToggle={createToggleExperienceHandler(item)}
                    isLegacy={isLegacy}
                  />
                )}
              />
            </SortableContext>
          </div>
        </div>

        <Divider />

        <div className="discover-list-experiences-container">
          <div className="staycation-discover-card__title">
            Other experiences
          </div>
          <div className="discover-list-experiences">
            <SortableContext items={otherExperiences.map((i) => i.id)}>
              <SList
                grid={{ gutter: 16, column: 1 }}
                data={otherExperiences}
                renderItem={(item) => (
                  <ExperienceListItem
                    experience={item}
                    mode={mode}
                    key={item.id}
                    onToggle={createToggleExperienceHandler(item)}
                    isLegacy={isLegacy}
                  />
                )}
              />
            </SortableContext>
          </div>
        </div>
      </DndContext>
    </Form.Item>
  );
};
